<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <div class="weight-wrapper">	
		<span v-show="value > 0">{{ value }}</span>
		<span v-show="value == 0">-</span>
	</div>

</app-view-sheet-field>

</template>

<script>

import wNumb from 'wnumb'

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			return wNumb({
				'decimals': 2
			}).to(this.item.game.weight_avg)

		}

	}

}

</script>

<style scoped>

</style>